import CardHeader from './CardHeaderIndex';

export default CardHeader;
